/*
 * @Author: your name
 * @Date: 2022-04-07 10:42:52
 * @LastEditTime: 2022-04-27 18:01:57
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ksh-doctor/src/service/HelpService.js
 */
import request from '@/utils/request'
import {API} from './apiConfig'

export function getArticleList(pageNo = 1, searchKey = '', categoryId = '', categoryName = '',pageSize= 20) {
	if (searchKey){
		categoryId = '';
		categoryName = ''
	}
	return request({
		url: API.getArticleList,
		method: 'get',
		params: {
			pageNo: pageNo,
			searchKey: searchKey,
			categoryId: categoryId,
			categoryName: categoryName,
			pageSize,
		},
	})
}
export function getArticleDetail(articleId = '') {
	return request({
		url: API.getArticleDetail,
		method: 'get',
		params: {
			articleId: articleId
		},
	})
}
export function getArticleMark(articleId = '', markType, act) {
	let params = {
		articleId: articleId,
	}
	if (markType === 'like') {
		params.like = act
	} else {
		params.hate = act
	}
	return request({
		url: API.getArticleMark,
		method: 'get',
		params: params
	})
}
export function postFeedback(content = '', imageUrls = []) {
	return request({
		url: API.postFeedback,
		method: 'post',
		data: {
			content,
			imageUrls,
		},
	})
}

export function postGoodProductRecommend({ productLink, screenshotUrl, remark }) {
	return request({
		url: API.postGoodProductRecommend,
		method: 'post',
		data: {
			productLink,
			screenshotUrl,
			remark,
		},
	})
}
